import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Navbar from 'components/Owner/Navbar';
import { Button, Typography } from 'components/common';

import './styles.scss';

const ServicePartners = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  return (
    <div>
      <Navbar />

      <div className="d-flex align-items-center justify-content-center">
        <div className="ps-2 px-2 service-partners-container gap-4 pb-3">
          <div className="d-flex flex-column gap-1">
            <Typography variant="h1" style={{ color: '#1E1E22' }}>
              Eon Ecosystem
            </Typography>

            <Typography variant="body1" style={{ color: 'rgba(18, 18, 22, 0.50)' }}>
              Trusted partnerships that enhance your rental experience
            </Typography>
          </div>

          <div className="partners-container">
            <div
              style={{
                borderRadius: '16px',
                border: '1px solid #DDE0EA',
                padding: '16px',
              }}
              className="d-flex flex-column gap-3"
            >
              <div className="d-flex gap-2 align-items-center">
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '16px',
                    backgroundImage: 'url(/images/sf-logo.png)',
                    backgroundColor: '#F5F5F5',
                    backgroundPosition: '-1.197px 0px',
                    backgroundSize: '570.342% 100%',
                    backgroundRepeat: 'no-repeat',
                  }}
                />

                <div>
                  <Typography variant="h2" style={{ color: '#1E1E22', margin: 0 }}>
                    StandardFleet
                  </Typography>
                </div>
              </div>

              <div>
                <Typography variant="body2" style={{ color: 'rgba(18, 18, 22, 0.50)' }}>
                  Standard Fleet provides a hardware-free EV fleet management platform with remote vehicle access,
                  maintenance alerts, and automated charging reimbursements.
                </Typography>
              </div>

              <div style={{ padding: '16px', backgroundColor: '#F5F5F5', borderRadius: '16px' }}>
                <div>
                  <Typography variant="body2" style={{ color: '#1E1E22' }}>
                    Partnership Benefits
                  </Typography>
                </div>

                <div>
                  <ul
                    style={{
                      listStyleType: 'disc',
                      listStylePosition: 'inside',
                      paddingLeft: 0,
                      marginLeft: 0
                    }}
                  >
                    <li style={{ color: '#1E1E22' }}>Real-time vehicle monitoring</li>
                    <li style={{ color: '#1E1E22' }}>Predictive maintenance alerts</li>
                    <li style={{ color: '#1E1E22' }}>Enhanced safety features</li>
                    <li style={{ color: '#1E1E22' }}>Fuel efficiency optimization</li>
                    <li style={{ color: '#1E1E22' }}>Detailed reporting & analytics</li>
                  </ul>
                </div>
              </div>

              <div>
                <Button
                  variant="primary"
                  onClick={() => { window.open('https://standardfleet.com', '_blank'); }}
                  className="flex-grow-1 w-md-fit m-0"
                >
                  Visit StandardFleet
                </Button>
              </div>
            </div>

            <div
              style={{
                borderRadius: '16px',
                border: '1px solid #DDE0EA',
                padding: '16px',
              }}
              className="d-flex flex-column gap-3"
            >
              <div className="d-flex gap-2 align-items-center">
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '16px',
                    backgroundImage: 'url(/images/joulez-logo.png)',
                    backgroundColor: '#F5F5F5',
                    backgroundPosition: '-1.197px 0px',
                    backgroundSize: '570.342% 100%',
                    backgroundRepeat: 'no-repeat',
                  }}
                />

                <div>
                  <Typography variant="h2" style={{ color: '#1E1E22', margin: 0 }}>
                    Joulez
                  </Typography>
                </div>
              </div>

              <div>
                <Typography variant="body2" style={{ color: 'rgba(18, 18, 22, 0.50)' }}>
                  Joulez offers a seamless EV rental experience focused on sustainability,
                  innovation, and customer ease. From curbside delivery to app-based controls.
                </Typography>
              </div>

              <div style={{ padding: '16px', backgroundColor: '#F5F5F5', borderRadius: '16px' }}>
                <div>
                  <Typography variant="body2" style={{ color: '#1E1E22' }}>
                    Partnership Benefits
                  </Typography>
                </div>

                <div>
                  <ul
                    style={{
                      listStyleType: 'disc',
                      listStylePosition: 'inside',
                      paddingLeft: 0,
                      marginLeft: 0
                    }}
                  >
                    <li style={{ color: '#1E1E22' }}>Instant booking confirmations</li>
                    <li style={{ color: '#1E1E22' }}>Mobile-first customer experience</li>
                    <li style={{ color: '#1E1E22' }}>Integrated payment solutions</li>
                    <li style={{ color: '#1E1E22' }}>24/7 customer support</li>
                    <li style={{ color: '#1E1E22' }}>Multi-language support</li>
                  </ul>
                </div>
              </div>

              <div>
                <Button
                  variant="primary"
                  onClick={() => { window.open('https://drivejoulez.com', '_blank'); }}
                  className="flex-grow-1 w-md-fit m-0"
                >
                  Visit Joulez
                </Button>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: '16px',
              background: 'linear-gradient(180deg, #173354 0%, #3370BA 100%)',
              borderRadius: '16px',
            }}
            className="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <div className="d-flex flex-column gap-2">
              <div>
                <Typography variant="h2" style={{ color: '#FFF' }}>
                  Interested in Partnering with Us?
                </Typography>
              </div>

              <div>
                <Typography variant="body2" style={{ color: '#FFF', textAlign: 'center' }}>
                  We're always looking for innovative partners to enhance our service offerings
                  and provide exceptional value to our customers.
                </Typography>
              </div>

              <div>
                <Button
                  variant="default"
                  onClick={() => { window.open('https://form.typeform.com/to/Sdkwl0c4?typeform-source=www.eonrides.com', '_blank'); }}
                  className="flex-grow-1 w-md-fit m-0"
                >
                  Book A Call
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePartners;
